/* The two marks a client's notes on file put on the board (Kevin, 2026-10-25).
 *
 *   <client-note :client-id>        beside a client's name, wherever the board
 *                                   writes it except on a square: this client
 *                                   has notes on file.
 *   <note-warn :client-id :staff-id> beside an offer to hand that client to a
 *                                   technician their notes name — "Do not book
 *                                   with Zenny". The desk reads the note and
 *                                   decides; the board does not guess intent.
 *
 * Both read through the store (`clientNotesFor`, `noteWarningFor`), so every
 * place asks the same question, and both draw nothing at all when there is
 * nothing to say. Hover shows the note; a tap shows it too, since a desk
 * tablet has no hover — and stops there, because most of these sit inside a
 * row that does something else when clicked.
 *
 * Registered globally in main.js: a mark this small should not need an import
 * in every component that writes a name.
 */
import * as Vue from 'vue';
import { store } from '../store.js';

function show(evt, text, kind) {
  evt.stopPropagation();
  evt.preventDefault();
  store.toast(text, kind);
}

export const ClientNote = {
  name: 'ClientNote',
  props: { clientId: { default: null } },
  setup: function (props) {
    var notes = Vue.computed(function () { return store.clientNotesFor(props.clientId); });
    var label = Vue.computed(function () { return 'Notes on file: ' + notes.value; });
    return {
      notes: notes, label: label,
      tap: function (evt) { show(evt, label.value, 'info'); }
    };
  },
  template: [
    '<span v-if="notes" class="client-note" role="img" :title="label" :aria-label="label"',
    '  @click="tap" @pointerdown.stop>',
    '  <svg viewBox="0 0 16 16" width="13" height="13" aria-hidden="true" focusable="false">',
    '    <path d="M3.5 1.5h6l3 3v10h-9z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>',
    '    <path d="M5.5 7.5h5M5.5 10h5M5.5 12.5h3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>',
    '  </svg>',
    '</span>'
  ].join('\n')
};

export const NoteWarn = {
  name: 'NoteWarn',
  props: { clientId: { default: null }, staffId: { default: null } },
  setup: function (props) {
    var notes = Vue.computed(function () {
      return store.noteWarningFor(props.clientId, props.staffId);
    });
    var label = Vue.computed(function () {
      var s = store.staffOf(props.staffId);
      return 'The client’s notes mention ' + (s ? s.name : 'this technician') + ': ' + notes.value;
    });
    return {
      notes: notes, label: label,
      tap: function (evt) { show(evt, label.value, 'warn'); }
    };
  },
  template: [
    '<span v-if="notes" class="note-warn" role="img" :title="label" :aria-label="label"',
    '  @click="tap" @pointerdown.stop>&#9888;</span>'
  ].join('\n')
};
